<template>
  <div id="map"></div>
</template>
<script>
  import mapboxgl from 'mapbox-gl'
  import CovidTracer from "../../model/CovidTracer";

  export default {
    data () {
      return {
        search: '',
        valid: false,
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        dialogError: false,
        dialogSuccess: false,
        opciones:[],
        editedIndex: -1,
        surveyData:{pregunta:"",tipoPregunta:"",tipoPreguntaData:[]},
        inputOpcion:"",
        surveyDataList:[],
        covidTracer: new CovidTracer(),
        covidTracerList: [],
        position:"",
        access_token:
                'pk.eyJ1IjoiYWZjb21wdWVjdWFkb3IiLCJhIjoiY2s4dndpcTBnMHFsOTNmbWhmMDlibmE3ayJ9.PRgXLABAxefWjvOsMVvFBw',
      };
    },methods:{

      cleanData(){
        this.$refs.form.reset()
        this.covidTracer = new CovidTracer()
        this.valid = false
        this.dialog = false
      },

      saveData(){
          this.covidTracer.value = JSON.stringify(this.surveyDataList)
          this.covidTracer.date = new Date()
          this.covidTracer.covid = this.$store.state.covid
          this.$store.dispatch('updateCovidTrace',this.covidTracer).then(response => {
            this.reloadData()
            this.dialogSuccess = true
          }, error => {
            this.$store.state.progress = false
            this.$store.state.dialogError = true
          })
          this.dialog= false
      },


      reloadData() {
        this.$store.dispatch('getCovidTraceListByCovidId',this.$store.state.covid.id).then(
                response => {
                  this.covidTracerList = this.$store.state.covidTraceList
                },
                error => {
                  this.$store.state.dialogError = true;
                }
        );
      },
      createMap() {
        mapboxgl.accessToken = this.access_token
        let map = new mapboxgl.Map({
          container: 'map',
          style: 'mapbox://styles/mapbox/dark-v10',
          center: [this.covidTracer.longitude, this.covidTracer.latitude],
          zoom: 14
        })
        let geojson = {
          type: 'FeatureCollection',
          features: [{
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [this.covidTracer.longitude, this.covidTracer.latitude]
            },
            properties: {
              title: 'Mapbox',
              description: 'Paciente'
            }
          }]
        };
        geojson.features.forEach(function(marker) {

          // create a HTML element for each feature
          let el = document.createElement('div');
          //el.className = 'marker';
          el.style.backgroundColor = 'red';
          el.style.backgroundSize= 'cover'
          el.style.width= '50px'
          el.style.height= '50px'
          el.style.borderRadius= '50%'
          el.style.cursor= 'pointer'

          // make a marker for each feature and add to the map
          new mapboxgl.Marker(el)
                  .setLngLat(marker.geometry.coordinates)
                  .addTo(map);
        });


      }
    },
    mounted() {
      setTimeout(() => {
      this.createMap()
      }, 1000);



    },
      computed : {
      },
      created(){
        this.covidTracer=this.$store.state.seguimiento
        this.surveyDataList=JSON.parse(this.$store.state.seguimiento.value)

      }
    }
</script>

<style scoped>
   #map{
    top: 0;
    bottom: 0;
    width: 100%;
    height: 700px;
  }
   .marker {
    background-image: url('../../assets/mapbox-icon.png');
    background-size: cover;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/covid/CovidTracerMap.vue